export default{ 
   
    experts:[
        {
        _id:101,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'Free',
        rating:4.9,
        views:120,
        company:'Founder @ The  co- Millennails & CEO @havehh',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"SEO",
        skill3:"React",
        skill4:"Node",
    },
       
        {
        _id:102,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 25',
        rating:4.2,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
    
    
    },
       
        {
        _id:103,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 45',
        rating:3.9,
        views:190,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Game Engine",
        skill3:"Video Animation",
        skill4:"JavaScript",    
    },
       
        {
        _id:104,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 50',
        rating:3.5,
        views:10,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:105,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 60',
        rating:4.9,
        views:180,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Marketing",
        skill3:"Market Excutive ",
        skill4:"SEO",    
        },
       
        {
        _id:106,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 10',
        rating:3.8,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:107,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 90',
        rating:2.7,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:108,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 50',
        rating:4.6,
        views:160,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:109,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 47',
        rating:4.9,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:110,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 56',
        rating:4.1,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:111,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'Free',
        rating:1.9,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:112,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 85',
        rating:4.2,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:113,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 35',
        rating:4.4,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:114,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'$ 76',
        rating:4.1,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       
        {
        _id:114,
        name:'David Melvik',
        image:'/images/mentorr.jpg',
        price:'Free',
        rating:4.0,
        views:120,
        company:'Founder @ The Millennails & CEO @ABC',
        sessiontime:'02 Free Sessions Available',
        area:'Tampla,FL,USA',
        languages:'Greek,French,English',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum ipsa exercitationem animi iure necessitatibus sint hic officia porro numquam vel qui, praesentium saepe, provident quo placeat laborum iusto, excepturi doloribus. laborum iusto doloribus.',
        skill1:"Marketing",
        skill2:"Online Content",
        skill3:"Video Animation",
        skill4:"SEO",    
        },
       

]
};